import { ApiWrapper } from '../../types';
import { OF } from '../../util';
import { JBaseApi } from '../base';

export class JitsiApi extends JBaseApi {
    public resolveUrl({ id }: { id: string }, signal?: AbortSignal): Promise<ApiWrapper<string>> {
        return this.network.post(
            {
                o: 'jitsi',
                f: 'resolveUrl',
                id,
            } as OF,
            signal,
        );
    }
}
